<hr class="mt-0" />

<div class="w-full category-picker">
  <!--
    The tree is shown inline rather than inside a p-treeSelect dropdown. This
    dialog exists only to pick categories, so wrapping the tree in a dropdown
    meant an overlay panel that had to escape the very dialog containing it -
    it either got clipped or hung off the bottom edge. Inline, the tree simply
    fills the dialog and scrolls on its own.
  -->
  <p-tree
    [value]="careerPaths"
    [(selection)]="selected"
    selectionMode="checkbox"
    [filter]="true"
    filterPlaceholder="{{ 'layout.configurations.pool.addPoolFilter.searchPlaceholder' | translate }}"
    filterBy="label"
    scrollHeight="22rem"
    styleClass="category-tree"
    emptyMessage="{{ 'layout.configurations.pool.addPoolFilter.noCategories' | translate }}">
  </p-tree>

  <div class="save-bar">
    <span class="selection-count">
      {{ selectedCategoryCount }}
      {{ 'layout.configurations.pool.addPoolFilter.selectedSuffix' | translate }}
    </span>
    <p-button
      label="{{ 'layout.configurations.pool.addPoolFilter.save' | translate }}"
      styleClass="p-button-sm"
      (onClick)="submitData()">
    </p-button>
  </div>
</div>
